import "core-js/modules/es6.number.constructor";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useRef, useLayoutEffect, useCallback } from 'react';
import classnames from 'classnames';
import { mainClassName, omissionClassName, baseClassName } from './constants';
import { STruncateWidthContainer } from './styles';
import { useTooltip } from './utils';

var TruncateByWidth = function TruncateByWidth(_ref) {
  var children = _ref.children,
      threshold = _ref.threshold,
      omission = _ref.omission,
      showTooltip = _ref.showTooltip,
      align = _ref.align,
      className = _ref.className,
      tooltipMaxWidth = _ref.tooltipMaxWidth,
      updaterRef = _ref.updaterRef,
      isOverflowChange = _ref.isOverflowChange;
  var ref = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOverflow = _useState2[0],
      setIsOverflow = _useState2[1]; // 通过css`text-overflow: ellipsis;`来渲染省略符，还是用react来渲染
  // css渲染方式能够以字符为单位进行截断，观感更好


  var omissionByCSS = omission === '...';
  var checkOverflow = useCallback(function () {
    var el = ref.current;

    if (!el) {
      // 尚未渲染完成
      return;
    }

    var newIsOverflow = isWidthOverflow(el);

    if (newIsOverflow !== isOverflow) {
      setIsOverflow(newIsOverflow);

      if (typeof isOverflowChange === 'function') {
        setTimeout(function () {
          isOverflowChange(newIsOverflow);
        }, 0);
      }
    }
  }, [isOverflow, isOverflowChange]);
  useLayoutEffect(function () {
    checkOverflow();
    if (_typeof(updaterRef) === 'object') // eslint-disable-next-line
      updaterRef.current = checkOverflow;
  });
  var truncateContainer = React.createElement(STruncateWidthContainer, {
    threshold: Number(threshold) || threshold,
    omissionByCSS: omissionByCSS,
    className: classnames(className, baseClassName)
  }, React.createElement("span", {
    ref: ref,
    className: mainClassName
  }, children), isOverflow && !omissionByCSS && React.createElement("span", {
    className: omissionClassName
  }, omission));
  return useTooltip({
    showTooltip: isOverflow && showTooltip,
    tooltipMaxWidth: tooltipMaxWidth,
    align: align,
    originalContent: children,
    truncatedContent: truncateContainer
  });
};

export default TruncateByWidth;

function isWidthOverflow(element) {
  // debugger
  return element.scrollWidth > element.clientWidth;
}